import React from 'react';
import {
  Result, Button,
} from 'antd';

const MagazineCarouselForm = ({ form }) => (
  <Result
    status="success"
    title="Magazine Carousel Form"
    subTitle="Loren Ipsum"
    extra={[
      <Button type="primary" key="console">
        Go Console
      </Button>,
      <Button key="buy">Buy Again</Button>,
    ]}
  />
);

export default MagazineCarouselForm;
